"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.default=()=>{let e="";const t="0123456789abcdef";for(let r=0;r<36;r+=1)e+=8===r||13===r||18===r||23===r?"-":14===r?"4":19===r?t[4*Math.random()|8]:t[Math.floor(16*Math.random())];return e};



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/~/@vds-core/utilities/cjs/components/UUIDGenerator/generateUUID.js
// module id = 899
// module chunks = 0